<template>
    <div data-click="no" >
        <a v-if="success_add" class="button_with_without_text agree vue_show_tooltip" @click="changeModal" data-click="no">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" data-click="no">
                <path d="M1 4.25C1 2.5 2 1.75 3.5 1.75H8.5C10 1.75 11 2.5 11 4.25V7.75C11 9.5 10 10.25 8.5 10.25H3.5" stroke="#34D399" stroke-linecap="round" stroke-linejoin="round" data-click="no"/>
                <path d="M8.5 4.5L6.935 5.75C6.42 6.16 5.575 6.16 5.06 5.75L3.5 4.5" stroke="#34D399" stroke-linecap="round" stroke-linejoin="round" data-click="no"/>
                <path d="M1 8.25H4" stroke="#34D399" stroke-linecap="round" stroke-linejoin="round" data-click="no"/>
                <path d="M1 6.25H2.5" stroke="#34D399" stroke-linecap="round" stroke-linejoin="round" data-click="no"/>
            </svg>
            <tool-tip class="vue_tooltip hide" side="l" :text="$t('offer.send_email_sent_on') + formattedDate(data[0].created_at)"/>
        </a>
        <a v-else class="button_with_without_text vue_show_tooltip" @click="changeModal" data-click="no">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" data-click="no">
                <path d="M1 4.25C1 2.5 2 1.75 3.5 1.75H8.5C10 1.75 11 2.5 11 4.25V7.75C11 9.5 10 10.25 8.5 10.25H3.5" stroke="#9CA3AF" stroke-linecap="round" stroke-linejoin="round" data-click="no"/>
                <path d="M8.5 4.5L6.935 5.75C6.42 6.16 5.575 6.16 5.06 5.75L3.5 4.5" stroke="#9CA3AF" stroke-linecap="round" stroke-linejoin="round" data-click="no"/>
                <path d="M1 8.25H4" stroke="#9CA3AF" stroke-linecap="round" stroke-linejoin="round" data-click="no"/>
                <path d="M1 6.25H2.5" stroke="#9CA3AF" stroke-linecap="round" stroke-linejoin="round" data-click="no"/>
            </svg>
            <tool-tip class="vue_tooltip hide" side="l" :text="$t('offer.send_tooltip')"/>
        </a>
        <div> 
            <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.1/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-+0n0xVW2eSR5OomGNYDnhzAbDsOXxcvSN1TPprVMTNDbiYZCxYbOOl7+AMvyTG2x" crossorigin="anonymous">
            <div v-show="modal" id="myModal" class="modal" @click.self="changeModal" ref="modalContent" data-click="no">
                <div class="modal-content" data-click="no">
                    <div class="modal-header" data-click="no">
                        <h1 data-click="no">{{ $t('offer.send_title') }}</h1>
                        <svg @click="changeModal" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none" data-click="no">
                            <path d="M8.25 24.75L24.75 8.25M8.25 8.25L24.75 24.75" stroke="#5C5C5C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-click="no"/>
                        </svg>
                    </div>
                    <div class="modal-line active" data-click="no"></div>
                    <div class="modal-body" data-click="no">
                        <div class="main" data-click="no">
                            <div class="form-floating mb-3" data-click="no">
                                <input v-model="email.sender" type="text" class="form-control sender" id="sender" :placeholder="$t('offer.send_sender_ph')" data-click="no" disabled>
                                <label for="sender" data-click="no">{{ $t('offer.send_sender_label') }}</label>
                            </div>
                            <div class="form-floating mb-3" data-click="no">
                                <input v-model="email.subject" type="text" class="form-control subject" id="subject" placeholder="Predment" data-click="no">
                                <label for="subject" data-click="no">Predment</label>
                            </div>
                            <div class="form-floating mb-3" data-click="no">
                                <input v-model="email.email_to" type="text" class="form-control email_to" id="email_to" :placeholder="$t('offer.send_to_ph')" data-click="no">
                                <label for="email_to" data-click="no">{{ $t('offer.send_to_label') }}</label>
                            </div>
                            <div class="form-group mb-3 mt-2 mobile_doba_inputs" data-click="no">
                                <div class="d-flex" data-click="no">
                                    <input v-model="sendCC"
                                           type="checkbox" class="toggle" data-click="no">
                                    <label class="block mb-0 mt-1" @click="sendCC = !sendCC" style="cursor:pointer;" data-click="no">
                                        {{ $t('offer.send_cc_checkbox') }}
                                    </label>
                                </div>
                                <div 
                                    v-show="sendCC" 
                                    class="doba_inputs mt-2" data-click="no">
                                    <div class="form-floating" data-click="no">
                                        <input v-model="email.email_cc" type="text" class="form-control email_cc" id="email_cc" :placeholder="$t('offer.send_cc_ph')" data-click="no">
                                        <label for="email_cc" data-click="no">{{ $t('offer.send_cc_label') }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="form-floating" data-click="no">
                                <textarea v-model="email.message" class="form-control" :placeholder="$t('offer.send_message_ph')" id="message" style="height: 162px" data-click="no"></textarea>
                                <label for="message" data-click="no">{{ $t('offer.send_message_label') }}</label>
                            </div>
                            <div class="first" data-click="no">
                                <form id="email_files" action="" method="post" enctype="multipart/form-data" :class="'email_files'+offer_uuid +' mt-4'" data-click="no">
                                    <input type="file" name="files" class="files" data-click="no"
                                        :data-fileuploader-files='preloadedofferfiles'
                                        />
                                        <div class="fileuploader-items" bis_skin_checked="1">
                                            <ul class="fileuploader-items-list">
                                                <li class="fileuploader-item file-type-application file-ext-pdf file-has-popup" style="border-bottom: 0; padding-top: 35px;">
                                                    <div class="columns" bis_skin_checked="1">
                                                        <div class="column-thumbnail" bis_skin_checked="1">
                                                            <div class="fileuploader-item-image fileuploader-no-thumbnail" bis_skin_checked="1">
                                                                <div style="background-color: #f23c0f" class="fileuploader-item-icon" bis_skin_checked="1">
                                                                    <i>pdf</i>
                                                                </div>
                                                            </div>
                                                            <span class="fileuploader-action-popup"></span>
                                                        </div>
                                                        <div class="column-title" bis_skin_checked="1">
                                                            <a>
                                                                <div title="martin_kubanda_superfaktura_11102023_DZZ1U.pdf" bis_skin_checked="1" style="margin-top: 6px;">
                                                                {{pdfName}}
                                                                </div>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                </form>
                            </div>
                        </div>
                        <div class="ulozit" @click="save" data-click="no">
                            <span v-show="!saved" id="saveKlient" data-click="no">{{ $t('offer.send_btn') }}</span>
                            <div v-show="saved" class=" lds-ellipsis" data-click="no">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                        <div v-if="data.length > 0"  class="history" data-click="no">
                            <h6 data-click="no">{{ $t('offer.send_history_title') }}</h6>
                            <div class="history_titles" data-click="no">
                                <span data-click="no" style="width: 90px;">{{ $t('offer.send_date_col') }}</span>
                                <span data-click="no" style="width: 210px;">{{ $t('offer.send_email_col') }}</span>
                                <span data-click="no">Predmet</span>
                                <span data-click="no">Text</span>
                            </div>
                            <div class="history_line" data-click="no"></div>
                            <div v-for="item in data" :key="item.id"  class="history_data" data-click="no">
                                <p data-click="no" style="width: 90px;">{{formattedDate(item.created_at)}}</p>
                                <p data-click="no" style="width: 210px;">{{item.email_to}} 
                                    <small v-if='item.email_cc'><br>{{ $t('offer.send_cc_prefix') }} {{item.email_cc}}</small>
                                </p>
                                <p data-click="no">{{item.subject}}</p>
                                <p v-if="item.message.length > 30" class="tooltip_history" data-click="no">
                                    <span data-click="no" class="">{{ truncatedMessage(item.message) }}</span>
                                    <span class="tooltiptext_history" data-click="no">{{ item.message }}</span>
                                </p>
                                <p v-else data-click="no">{{ item.message }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ToolTip from '../../vue_components/ToolTip.vue';
export default {
    props: ['offer_uuid','user','klient_name','klient_email', 'offer_email', 'url', 'sendEmail'],
    components: {ToolTip},
    data() {
        return {
            modal: false,
            saved:false,
            sendCC: false,
            files: [],
            preloadedofferfiles: "",
            pdfName: "",
            email: {
                sender: "",
                subject: "",
                email_to: "",
                email_cc: "",
                message: "",
                hash: ""
            },
            data: null,
            success_add: false,
        }
    },
    watch: {
        sendEmail(newVal) {
            if (newVal != null && newVal == this.offer_uuid) {
                this.changeModal()
            }
        }
    },
    created () {
        this.setEmail()
        var t = this
        $(document).ready(function() {
            $.ajaxSetup({
                headers: {
                    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
                }
            });
            $(".email_files"+t.offer_uuid+" input.files").fileuploader({
                addMore: true,
                limit: 4,
                maxSize: 8,
                extensions: ['zip', 'docx', 'doc', 'rar', 'jpeg', 'jpg', 'png', 'pdf', 'csv', 'xls', 'xlsx', 'svg'],
                fileMaxSize: 8,
                changeInput:
                            '<div class="fileuploader-input" >' +
                            t.$t('offer.send_attachments_title')+
                            '<div class="fileuploader-input-inner" >' +
                            '<div class="fileuploader-icon-main" ></div>' +
                            '<h3 class="fileuploader-input-caption" ><span >${captions.feedback}</span></h3>' +
                            '<p >${captions.or}</p>' +
                            '</div>' +
                            '</div>',
                theme: "dragdrop",
                thumbnails: {
                    onImageLoaded: function(item) {
                        t.files.push(item)
                    },
                },
                editor: {
                    cropper: {
                        showGrid: true
                    }
                },
                captions: $.extend(true, {}, $.fn.fileuploader.languages["en"], {
                    feedback: t.$t('offer.send_upload_feedback'),
                    feedback2: t.$t('offer.send_upload_feedback'),
                    drop: t.$t('offer.send_upload_drop'),
                    or: "",
                    button: "",
                    remove: t.$t('offer.send_file_remove'),
                    download: t.$t('offer.send_file_download'),
                    removeConfirmation: t.$t('offer.send_file_remove_confirm'),
                    errors: {
                        filesLimit: function(e) {
                            t.$toast.warning(t.$t('offer.send_warning_five_files'), {
                                timeout: 5000,
                            })
                        },
                        filesSizeAll: function(e){
                            t.$toast.warning(t.$t('offer.send_warning_too_large') + e.maxSize + t.$t('offer.send_warning_too_large_mb'), {
                                timeout: 5000,
                            })
                        },
                        filesType: function(e) {
                            t.$toast.warning(t.$t('offer.send_warning_type'), {
                                timeout: 5000,
                            })
                        },
                        fileSize: function(e) {
                            t.$toast.warning(e.name + t.$t('offer.send_warning_file_large') + e.fileMaxSize + t.$t('offer.send_warning_too_large_mb'), {
                                timeout: 5000,
                            })
                        }
                    }
                }),
                onRemove: function(item) {
                    for( var i = 0; i < t.files.length; i++){ 
                        if ( t.files[i] == item) { 
                            t.files.splice(i, 1)
                            i--
                        }
                    }
                },

            });
        })
    },
    methods: {
        setEmail(){
            this.data = this.offer_email
            this.email.sender =  this.user.email
            this.email.subject = this.$t('offer.send_email_subject')
            this.email.email_to =  this.klient_email
            this.email.email_cc =  ""
            this.email.message =  "Dobrý deň, v prílohe vám posielame cenovú ponuku podľa predošlej komunikácie.\n\nPonuka je tiež dostupná online na URL: " + window.location.origin + this.url
            
            this.generatePdfName()
            this.checkEmailStatus()
        },
        checkEmailStatus(){
            if(this.data.length > 0){
                this.success_add = true
            }
        },
        changeModal() {
            this.modal = !this.modal
            if(this.modal){
                document.documentElement.style.overflow = 'hidden';
            }else{
                document.documentElement.style.overflow = 'auto';
            }
        },
        save() {

            if (!this.email.subject) {
                this.$toast.warning(this.$t('offer.send_warning_subject'), { timeout: 2500 })
                return;
            } 
            if (!this.email.email_to) {
                this.$toast.warning(this.$t('offer.send_warning_email'), { timeout: 2500 })
                return;
            }
            if (!this.isValidEmail(this.email.email_to)) {
                this.$toast.warning(this.$t('offer.send_warning_email_format'), { timeout: 2500 })
                return;
            }
            if (!this.email.message) {
                this.$toast.warning(this.$t('offer.send_warning_message'), { timeout: 2500 })
                return;
            } 
            this.saved = true
            const fd = new FormData();
            this.files.forEach(fileObject => {
                fd.append('files[]', fileObject.file);
            });
            fd.append('offer_uuid', this.offer_uuid);
            fd.append('subject', this.email.subject);
            fd.append('email_to', this.email.email_to);
            fd.append('email_cc', this.email.email_cc);
            fd.append('message', this.email.message);
            fd.append('hash', this.email.hash);
            axios.post('/api/offers/offer/email/send',fd).then(response => {
                this.changeModal()
                this.$toast.success(this.$t('offer.send_success_sent'), { timeout: 3500 })
                this.saved = false
                this.data.push(response.data)
                this.success_add = true

                const gtmEventData = {
                    event: 'email_quote_sent',
                    'Event category': 'email',
                    'Event action': 'successfull_sent_email',
                    'Event label': 'send_offer_by_doffero'
                };
                this.$gtm.push(gtmEventData);

            })
        },
        isValidEmail(email) {
            const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
            return emailPattern.test(email);
        },
        truncatedMessage(message) {
            if (message.length > 20) {
                return message.substring(0, 20) + "...";
            } else {
                return message;
            }
        },
        generatePdfName() {
            this.email.hash =  this.generateRandomHash(5);
            var time = this.getCurrentDate();
            var name = this.slugify(this.klient_name.toLowerCase());
            this.pdfName =  name + '_'+ time +'_' + this.email.hash  +'.pdf'
        },
        generateRandomHash(length) {
            const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            let result = "";
            for (let i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() * characters.length));
            }
            return result;
        },
        getCurrentDate() {
            const date = new Date();
            return (
                String(date.getDate()).padStart(2, "0") +
                String(date.getMonth() + 1).padStart(2, "0") +
                date.getFullYear()
            );
        },
        slugify(text) {
            return text.replace(/ /g, "_").toLowerCase();
        },
        formattedDate(item_date) {
            const date = new Date(item_date);
            const day = date.getDate();
            const month = date.getMonth() + 1; // Month is 0-based, so add 1
            const year = date.getFullYear();
            const formattedDay = String(day).padStart(2, '0');
            const formattedMonth = String(month).padStart(2, '0');
            return `${formattedDay}.${formattedMonth}. ${year}`;
        },
    },
    mounted () {
        $( ".tooltip_hover" ).hover(
            function() {
                $( this ).parent().find('.my_tooltip').css('opacity', '1');
            },
            function() {
                $( this ).parent().find('.my_tooltip').css('opacity', '0');
            },
        );
    },
}
</script>

<style lang="scss">

#email_files {
    .fileuploader{
        background: transparent;
        margin: 0;
        padding: 0;
    }
    .fileuploader-items .fileuploader-item:last-child{
        border-bottom: 1px solid #ebeef1;
    }
    .fileuploader-theme-dragdrop .fileuploader-input{
        position: relative;
        border: 1px dashed #DDE3E8;
        padding: 15px;
        height: 91px;
        .top_left{
            position: absolute;
            left: 15px;
            top: 15px;
            font-family: Roboto;
            font-style: normal;
            font-weight: bold;
            font-size: 11px;
            line-height: 13px;
            letter-spacing: 0.1em;
            text-transform: uppercase;
            color: #9598A7;
        }
        .fileuploader-input-inner{    
            margin-top: 14px;
            height: 100%;
            display: flex;
            align-items: center;
        }
    }
    .fileuploader-theme-dragdrop .fileuploader-input .fileuploader-icon-main{
        margin: 0;
        font-size: 32px;
    }
    h3.fileuploader-input-caption{
        margin: 0;
        display: block;
        flex: none;
        align-self: center;
        margin-left: 10px;
        font-family: Roboto;
        font-style: normal;
        font-size: 14px;
        line-height: 16px;
         span{
            font-weight: normal;
            color: #263544;
        }
        .nahraj{
            font-weight: 600;
            color: #2ED8B6;
            text-decoration: underline;
        }
    }
}
</style>
<style lang="scss" scoped>
label{
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #212541;
}
input[type="checkbox"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
    margin: 0px 10px 0 0px;
    background: #C7D4EB;
    border-radius: 25px;
}
.toggle{
    height: 22px;
    width: 40px;
    display: inline-block;
    position: relative;
    margin: 0;
    border: none;
    background: #FFFFFF;
    border-radius: 3px;
    transition: all 0.2s ease;
    &:focus {
        outline: 0;
    }
    &:after {
        content: "";
        position: absolute;
        top: 4px;
        left: 3px;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: white;
        box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
        transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
    }
    &:checked {
        border-color: #2ED8B6;
        background: #2ED8B6;
    }
    &:checked:after {
        transform: translatex(20px);
        
    }
}
.mobile_doba_inputs{
    display: grid !important;
}
.doba_inputs{
    background: white;
    width: 100%;
}
.vue_show_tooltip{
    position: relative;
}
.history{
    width: 100%;
    background-color: #fff;
    padding-top: 15px;    
    h6{
        text-align: center;
        color: var(--Blue, #212541);
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }
    .history_titles{
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        margin-top: 12px;
        span{    
            width: 150px;
            color: #9598A7;
            font-family: Roboto;
            font-size: 11px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            letter-spacing: 1.1px;
            text-transform: uppercase;
        }
    }
    .history_line{
        width: 100%;
        height: 1px;
        background: #DDE3E8;
        margin: 10px 0;
    }
    .history_data{
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        padding-bottom: 24px;
        p{
            width: 150px;
            color: #000;
            font-family: Roboto;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            padding: 0;
            margin: 0;
        }
    }
    .tooltip_history {
        border-bottom: 2px dashed #33333375;
        position: relative;
        display: inline-block;
        cursor: pointer;
    }

    .tooltip_history .tooltiptext_history {
        visibility: hidden;
        width: auto;
        background-color: #f0f0f0;
        color: #333;
        text-align: left;
        padding: 8px;
        border-radius: 4px;
        position: absolute;
        z-index: 1;
        bottom: 125%;
        left: 0;
        opacity: 0;
        transition: opacity 0.2s;
    }

    .tooltip_history:hover .tooltiptext_history {
        visibility: visible;
        opacity: 1;
    }
}
.button_with_without_text{
    cursor: pointer;
    width: 28px;
    height: 28px;
    padding: 2px 2px;
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 24px;
    background: #F3F4F6;
    transition: all .3s;
    &:hover{
        background: #e2e2e2;
    }
    &.agree{
        background: #ECFDF5;
        &:hover{
            background: #cfffe8;
        }
    }
}
.lds-ellipsis {
display: inline-block;
position: relative;
width: 80px;
height: 80px;
}
.lds-ellipsis div {
position: absolute;
top: 33px;
width: 13px;
height: 13px;
border-radius: 50%;
background: #fff;
animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
left: 8px;
animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
left: 8px;
animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
left: 32px;
animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
left: 56px;
animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
0% {
    transform: scale(0);
}
100% {
    transform: scale(1);
}
}
@keyframes lds-ellipsis3 {
0% {
    transform: scale(1);
}
100% {
    transform: scale(0);
}
}
@keyframes lds-ellipsis2 {
0% {
    transform: translate(0, 0);
}
100% {
    transform: translate(24px, 0);
}
}  
.ulozit{
    width: 578px;
    height: 55px;
    margin: 21px auto 60px auto;
    background: #2ED8B6;
    border: none;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 182.5%;
    color: #FFFFFF;
    cursor: pointer;
    transition: .5s all;
    &:hover{
        background: #26b195;
    }
    @media only screen and (max-width: 600px) {
        width: 95%;
    }
}
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap');
.form-floating>label{
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    letter-spacing: 0.05em;
    margin-top: 5px;
    text-transform: uppercase;
    color: #9598A7;
}
.form-group{
    @media only screen and (max-width: 600px) {
        width: 95%;
    }
}
*{
    font-family: 'Roboto', sans-serif;
}
.form-floating{
    width: 100%;
    margin: 0 auto;
    position: relative;
    .counter{
        position: absolute;
        right: 5px;
        bottom: 5px;
        font-size: 10px;
        font-weight: 300;
        color: #9598A7;
    }
    input{
        border: 1px solid #DDE3E8;
        border-radius: 0;
    }
    label{
        color: #9598A7;
        font-family: Roboto;
        font-size: 11px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        letter-spacing: 1.1px;
        text-transform: uppercase;
    }
    textarea{
        padding-top: 30px;
        border: 1px solid #DDE3E8;
        border-radius: 0;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
        color: #212541;
    }
}
.modal {
    display: block;
    position: fixed; 
    z-index: 10000; 
    left: 0;
    top: 0;
    width: 100%; 
    height: 100%; 
    overflow: auto; 
    background: rgba(33, 37, 65, 0.89);
    backdrop-filter: blur(5px);
    .modal-content {
        cursor: default;
        margin: 100px auto 100px auto;
        background: #F7F7F7;
        width: 674px;
        border-radius: 4px;
        box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.05);
        .modal-line{
            width: 673px;
            height: 1px;
            background: rgba(215, 60, 120, 0.40);
            transition: opacity .5s;
            &.active{
                background: #D73C78;
            }
        }
        .modal-header{
            margin: 35px auto;
            width: 578px;
            display: flex;
            align-items: center;
            padding: 0;
            border: none;
            h1{
                width: 427px;
                height: 34px;
                text-align: left;
                font-family: Roboto;
                font-size: 29px;
                font-style: normal;
                font-weight: 300;
                line-height: normal;
                color: #212541; 
            }
            svg{
                transition: transform .5s;
                &:hover{
                    cursor: pointer;
                    transform: scale(1.3);
                }
            }
        }
        .modal-body{
            padding: 0;
            .main{
                width: 578px;
                margin: 0 auto;
                border-radius: 4px;
                background: #FFF;
                box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.05);
                padding: 20px;
                margin-top: 22px;
                @media only screen and (max-width: 600px) {
                    width: 95%;
                }
                h3{
                    width: auto;
                    font-family: 'Roboto';
                    font-style: normal;
                    font-weight: 700;
                    font-size: 18px;
                    line-height: 21px;
                    color: #212541;
                }
                p{
                    font-family: 'Roboto';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 16px;
                    color: #9598A7;
                }
            }
        }
    }
}
</style>